import _ from 'lodash-es';
import YAML from 'yaml';
import GenericHelper from '@/core/helpers/genericHelper';
import { ExternalStackViewModel } from '@/core/models/stack';

angular.module('shbdeployer.app').factory('StackHelper', [
  function StackHelperFactory() {
    'use strict';
    var helper = {};

    helper.getExternalStacksFromContainers = function (containers) {
      return getExternalStacksFromLabel(containers, 'com.docker.compose.project', 2);
    };

    helper.getExternalStacksFromServices = function (services) {
      return getExternalStacksFromLabel(services, 'com.docker.stack.namespace', 1);
    };

    function getExternalStacksFromLabel(items, label, type) {
      return _.uniqBy(
        items.filter((item) => item.Labels && item.Labels[label]).map((item) => new ExternalStackViewModel(item.Labels[label], type, item.Created)),
        'Name'
      );
    }

    helper.validateYAML = function (yaml, containerNames) {
      let yamlObject;

      try {
        yamlObject = YAML.parse(yaml);
      } catch (err) {
        return 'Ошибка в синтаксисе YAML: ' + err;
      }

      const names = _.uniq(GenericHelper.findDeepAll(yamlObject, 'container_name'));
      const duplicateContainers = _.intersection(containerNames, names);

      if (duplicateContainers.length === 0) return;

      return (
        (duplicateContainers.length === 1 ? 'Имя контейнера уже используется' : 'Имена контейнеров уже используются') +
        ' другим контейнером в этом окружении: ' +
        _.join(duplicateContainers, ', ') +
        '.'
      );
    };

    return helper;
  },
]);
